import { GLU_SWITCH_VIEW } from "../../Redux/Actions/GLUActions";

export type State = "LIST" | "STATUS" | "CREATE" | "INFO";

const initialState: ViewState = {
  state: 'LIST',
  pageData: {}
};

export type ViewState = {
  state: State,
  pageData: any
}

export const GLUViewReducer = (state = initialState, action: { payload: ViewState; type: any }) => {
  switch (action.type) {
    case GLU_SWITCH_VIEW:
      return action.payload;
    default:
      return state;
  }
};
